import React, { useState } from "react";
import { Modal, Table, Badge, Button, Collapse, Card } from "react-bootstrap";
import { FaSync, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Icon } from "../../../../../components/common/Icon";

interface IngestionHistoryModalProps {
    show: boolean;
    onHide: () => void;
    source: any;
    jobs: any[];
    loading: boolean;
    onRefresh: () => void;
}

const IngestionHistoryModal: React.FC<IngestionHistoryModalProps> = ({
    show,
    onHide,
    source,
    jobs,
    loading,
    onRefresh,
}) => {
    const [expandedJobId, setExpandedJobId] = useState<number | null>(null);

    const toggleExpand = (jobId: number) => {
        setExpandedJobId(expandedJobId === jobId ? null : jobId);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Ingestion History
                    {source && <small className="text-muted ms-2">for {source.title}</small>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-end mb-3">
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={onRefresh}
                        disabled={loading}
                    >
                        <Icon icon={FaSync} className={loading ? "fa-spin me-1" : "me-1"} />
                        Refresh
                    </Button>
                </div>

                <div className="table-responsive">
                    <Table size="sm" hover>
                        <thead>
                            <tr>
                                <th style={{ width: "80px" }}>Job ID</th>
                                <th>Status</th>
                                <th style={{ width: "80px" }}>Version</th>
                                <th>Created</th>
                                <th style={{ width: "50px" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center text-muted py-3">
                                        No ingestion jobs found for this source.
                                    </td>
                                </tr>
                            ) : (
                                jobs.map((job) => (
                                    <React.Fragment key={job.id}>
                                        <tr
                                            onClick={() => toggleExpand(job.id)}
                                            style={{ cursor: "pointer" }}
                                            className={expandedJobId === job.id ? "table-active" : ""}
                                        >
                                            <td>#{job.id}</td>
                                            <td>
                                                <Badge
                                                    bg={
                                                        job.status === "succeeded"
                                                            ? "success"
                                                            : job.status === "failed"
                                                                ? "danger"
                                                                : job.status === "running"
                                                                    ? "primary"
                                                                    : "warning"
                                                    }
                                                >
                                                    {job.status}
                                                </Badge>
                                            </td>
                                            <td>v{job.version}</td>
                                            <td className="small">
                                                {new Date(job.created_at).toLocaleString()}
                                            </td>
                                            <td className="text-center">
                                                <Icon
                                                    icon={expandedJobId === job.id ? FaChevronUp : FaChevronDown}
                                                    size={12}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="p-0">
                                                <Collapse in={expandedJobId === job.id}>
                                                    <div>
                                                        <Card className="border-0 rounded-0">
                                                            <Card.Body className="bg-light">
                                                                <div className="row g-2">
                                                                    <div className="col-md-6">
                                                                        <strong>Started At:</strong>{" "}
                                                                        <span className="small">
                                                                            {job.started_at
                                                                                ? new Date(job.started_at).toLocaleString()
                                                                                : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <strong>Finished At:</strong>{" "}
                                                                        <span className="small">
                                                                            {job.finished_at
                                                                                ? new Date(job.finished_at).toLocaleString()
                                                                                : "-"}
                                                                        </span>
                                                                    </div>
                                                                    {job.stats && Object.keys(job.stats).length > 0 && (
                                                                        <div className="col-12">
                                                                            <strong>Stats:</strong>
                                                                            <pre className="bg-white p-2 rounded small mb-0 mt-1" style={{ maxHeight: "150px", overflow: "auto" }}>
                                                                                {JSON.stringify(job.stats, null, 2)}
                                                                            </pre>
                                                                        </div>
                                                                    )}
                                                                    {job.error && (
                                                                        <div className="col-12">
                                                                            <strong className="text-danger">Error:</strong>
                                                                            <div className="alert alert-danger small mb-0 mt-1">
                                                                                {job.error}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                </Collapse>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end">
                <Button variant="outline-secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default IngestionHistoryModal;
